module.exports = __webpack_public_path__ + "media/components/assets/images/notice_default_img-21e892376dbf534c4fbe75ffeb7027fb.svg";